import { IUser, ILoginResponse } from 'src/interfaces/user';

export const SIGN_IN = 'SIGN_IN';
export const FETCH_USER = 'FETCH_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export interface IReducerAuthState {
  user?: IUser | any;
  token?: any;
}

export interface ISignInUser {
  type: typeof SIGN_IN;
  payload: ILoginResponse;
}

export interface IFetchUser {
  type: typeof FETCH_USER;
  payload: IUser;
}

export interface ILogoutUser {
  type: typeof LOGOUT_USER;
}

export type AuthActionTypes = ISignInUser | IFetchUser | ILogoutUser;
